import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger'
import Immutable from 'immutable';
import rootReducer from '../reducers';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';

const initialState = Immutable.Map();


export default createStore(
    rootReducer,
    initialState,
    composeWithDevTools(
        applyMiddleware(thunk, createLogger({stateTransformer: state => state.toJS()})),
    )
);


// WEBPACK FOOTER //
// ./src/dashboards_redux/store/configureStore.jsx